import { DutyLineNote } from 'RestAPIs/employees/hours-table/types';
import { EmployeeNotesResponse } from 'RestAPIs/employees/notes';
import { NOTE_VARIANT } from './Notes.consts';

export enum NotesTypeEnums {
  EMPLOYEE_NOTE = 'employeeNote',
  DUTY_LINE = 'dutyLine',
  FLEX_MATCH_REQUEST = 'flexMatchRequest'
}

export type NotesType =
  | NotesTypeEnums.EMPLOYEE_NOTE
  | NotesTypeEnums.DUTY_LINE
  | NotesTypeEnums.FLEX_MATCH_REQUEST;

export type NoteVariant = (typeof NOTE_VARIANT)[keyof typeof NOTE_VARIANT];

export type NoteComponentSize = 'compact' | 'default';

export type NotesProps = {
  employeeId?: number;
  type?: NotesType;
  noteData?: DutyLineNote[] | EmployeeNotesResponse[] | null;
  dutyLineId?: number;
  isEmployeePortal?: boolean;
  isSavedByParent?: boolean;
  onAddNote?: (note: DutyLineNote) => void;
  onRemoveNote?: (noteId: number) => void;
  noteVariant?: NoteVariant;
  size?: NoteComponentSize;
  requestId?: number;
  showTooltip?: boolean;
  isWebSocketEnabled?: boolean;
};
